import { useEffect, useState } from 'react';
import useVideoRoom from '../video/utils/useVideoRoom';
import { State } from '../video/types/Video';
import { InCallUpgrade } from '../video/inCallUpgrade/inCallUpgrade';
import { PostCall } from '../video/postCall/PostCall';
import Loading from '../video/loading/Loading';
import { useLocation } from 'react-router-dom';
import { logger } from 'utils/logger';


const VideoUpgrade = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const interactionId = searchParams.get('interactionId');
    const qRoomId = searchParams.get('roomId');
    const qAccountId = searchParams.get('accountId');
    const [currentState, setCurrentState] = useState<State>('preUpgrade');
    const {
        room,
        localVideoTrack,
        localAudioTrack,
        remoteAudioTrack,
        remoteVideoTrack,
        availableDevices,
        selectedDevices,
        microphoneMuted,
        toggleMicrophone,
        cameraMuted,
        toggleCamera,
        applyBlurOnInCallVideo,
        TurnCameraOnInCallVideo,
        updateDevice,
        initUpgradeRoom,
        isVideoBlurred,
        setMicrophoneMuted,
        sendFinalStats,
        cameraPermissionDenied,
    } = useVideoRoom();

    const changeCurrentState = (state: State) => {
        setCurrentState(state);
    };

    useEffect(() => {
        if (qRoomId) {
            logger.info('VideoUpgrade component initialized', 'VideoUpgrade', {
                roomId: qRoomId,
                accountId: qAccountId,
                interactionId
            });
            initUpgradeRoom(Number(qAccountId), qRoomId);
            changeCurrentState('inCall');
        }
    }, [qRoomId]);

    useEffect(() => {
        if (currentState === 'inCall') {
            logger.info('Entering inCall state', 'VideoUpgrade', {
                hasLocalAudioTrack: !!localAudioTrack
            });
            setMicrophoneMuted(true);
            if (localAudioTrack) {
                localAudioTrack.enabled = false;
                logger.info('Local audio track disabled for upgrade', 'VideoUpgrade');
            }
        }
    }, [currentState, localAudioTrack, setMicrophoneMuted]);

    if (currentState === 'preUpgrade') return <Loading />;

    if (currentState === 'inCall')
        return (
            <>
                <InCallUpgrade
                    changeCurrentState={changeCurrentState}
                    localVideoTrack={localVideoTrack}
                    localAudioTrack={localAudioTrack}
                    remoteVideoTrack={remoteVideoTrack}
                    remoteAudioTrack={remoteAudioTrack}
                    activeCall={undefined}
                    room={room}
                    microphoneMuted={microphoneMuted}
                    cameraMuted={cameraMuted}
                    toggleMicrophone={toggleMicrophone}
                    toggleCamera={toggleCamera}
                    availableDevices={availableDevices}
                    selectedDevices={selectedDevices}
                    updateDevice={updateDevice}
                    isVideoBlurred={isVideoBlurred}
                    applyBlurOnInCallVideo={applyBlurOnInCallVideo}
                    TurnCameraOnInCallVideo={TurnCameraOnInCallVideo}
                    sendFinalStats={sendFinalStats}
                    cameraPermissionDenied={cameraPermissionDenied}
                />
            </>
        );

    if (currentState === 'postCall')
        return (
            <>
                <PostCall changeCurrentState={changeCurrentState} isVideoUpgrade={true} />
            </>
        );

    return null;
};

export default VideoUpgrade;